/** InsCoder 2026-06-25 B + Recently viewed localStorage read and search section render **/
(function () {
  const STORAGE_KEY = 'cafune-recent-products';

  function getRecentProducts() {
    if (!window.localStorage) {
      return {};
    }

    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function getRecentEntries(excludeHandle, limit) {
    const recent = getRecentProducts();
    const entries = Object.keys(recent)
      .filter(function (handle) {
        return handle && handle !== 'undefined' && handle !== excludeHandle;
      })
      .map(function (handle) {
        return {
          handle: handle,
          id: recent[handle] && recent[handle].id ? String(recent[handle].id) : ''
        };
      });

    if (limit && entries.length > limit) {
      return entries.slice(entries.length - limit);
    }

    return entries;
  }

  function buildSearchQuery(entries) {
    const idQuery = entries
      .filter(function (entry) {
        return entry.id;
      })
      .map(function (entry) {
        return 'id:' + entry.id;
      })
      .join(' OR ');

    if (idQuery) {
      return idQuery;
    }

    return entries
      .map(function (entry) {
        return 'handle:' + entry.handle;
      })
      .join(' OR ');
  }

  function reorderProductItems(grid, entries) {
    const items = Array.prototype.slice.call(grid.querySelectorAll('[data-js-product-item]'));
    const orderMap = {};

    entries.forEach(function (entry, index) {
      orderMap[entry.handle] = index;
    });

    items.sort(function (a, b) {
      const aHandle = (a.dataset.productUrl || '').split('/products/').pop().split('?')[0];
      const bHandle = (b.dataset.productUrl || '').split('/products/').pop().split('?')[0];
      const aIndex = orderMap[aHandle] !== undefined ? orderMap[aHandle] : 999;
      const bIndex = orderMap[bHandle] !== undefined ? orderMap[bHandle] : 999;
      return aIndex - bIndex;
    });

    items.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function initQuickBuyForms(root) {
    root.querySelectorAll('form').forEach(function (form) {
      const template = form.querySelector('template');
      if (template) {
        form.append(template.content.cloneNode(true));
      }
    });
  }

  /** InsCoder 2026-06-25 B + Re-init product card image sliders after dynamic render **/
  function refreshProductCardSliders(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('.product-item css-slider.product-item__slider').forEach(function (slider) {
      if (slider.sliderEnabled && typeof slider.resetSlider === 'function') {
        slider.resetSlider(true, true);
      }
    });

    window.dispatchEvent(new Event('resize'));
  }
  /** InsCoder 2026-06-25 E + Re-init product card image sliders after dynamic render **/

  function refreshSectionSlider(root) {
    const slider = root.querySelector('css-slider.css-slider--bottom-navigation');
    if (slider && typeof slider.resetSlider === 'function') {
      slider.resetSlider();
    }
  }

  function RecentlyViewedSection(root) {
    this.root = root;
    this.loaded = false;
  }

  RecentlyViewedSection.prototype.loadProducts = function () {
    const excludeHandle = this.root.dataset.productHandle || '';
    const limit = parseInt(this.root.dataset.limit, 10) || 6;
    const entries = getRecentEntries(excludeHandle, limit);

    if (!entries.length) {
      this.root.hidden = true;
      return;
    }

    const shopifyRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const sectionKey = this.root.dataset.sectionKey || 'cust-recently-viewed';
    const query = buildSearchQuery(entries);
    const url = shopifyRoot + 'search?type=product&q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last&section_id=' + encodeURIComponent(sectionKey);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(this.onFetchSuccess.bind(this, entries))
      .catch(function (error) {
        console.error(error);
        this.root.hidden = true;
      }.bind(this));
  };

  RecentlyViewedSection.prototype.onFetchSuccess = function (entries, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fetchedGrid = doc.querySelector('[data-recently-viewed-grid]');
    const targetGrid = this.root.querySelector('[data-recently-viewed-grid]');

    if (!fetchedGrid || !targetGrid) {
      this.root.hidden = true;
      return;
    }

    const products = fetchedGrid.querySelectorAll('[data-js-product-item]');
    if (!products.length) {
      this.root.hidden = true;
      return;
    }

    targetGrid.innerHTML = '';
    products.forEach(function (productNode) {
      targetGrid.appendChild(productNode);
    });

    reorderProductItems(targetGrid, entries.slice().reverse());
    this.root.hidden = false;
    initQuickBuyForms(this.root);

    requestAnimationFrame(function () {
      refreshProductCardSliders(this.root);
      refreshSectionSlider(this.root);
      this.loaded = true;
      this.root.dispatchEvent(new Event('recently-viewed-loaded'));
    }.bind(this));
  };

  function initRecentlyViewed(root) {
    if (root.dataset.recentlyViewedInit === 'true') {
      return;
    }

    root.dataset.recentlyViewedInit = 'true';
    root.hidden = true;

    const section = new RecentlyViewedSection(root);
    section.loadProducts();
  }

  function initAll() {
    document.querySelectorAll('[data-recently-viewed-root]').forEach(initRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-recently-viewed-root]').forEach(initRecentlyViewed);
  });
})();
/** InsCoder 2026-06-25 E + Recently viewed localStorage read and search section render **/
